import * as React from 'react';



export default class Chev extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} viewBox="0 0 16 16" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="exzeo_2.x_icon_set" stroke="" strokeWidth="" fill="none" fillRule="evenodd" transform="translate(-71.000000, -225.000000)" strokeLinecap="round">
          <polyline id="Path-2-Copy" className="" stroke="" points="82 226 74.5311137 232.5 82 239"></polyline>
        </g>
      </svg>
    )
  }
}
